import styled, { css } from 'styled-components';

import { ValidationInfoStylesProps } from './PasswordValidationInfo.types';

export const ValidationInfo = styled.div<ValidationInfoStylesProps>(
  ({ theme: { palette, shape }, $isError, $isVisible }) => css`
    grid-column: span 2;
    background-color: ;
    background-color: ${$isError ? '#FEF5F3' : '#eff0f5'};
    padding: 0px 16px;
    border-radius: ${shape.borderRadius}px;
    color: ${$isError ? palette.error.main : palette.grey[600]};
    visibility: ${$isVisible ? 'visible' : 'hidden'};
    font-weight: 700;
    font-size: 12px;
    margin-top: 4px;
  `,
);

export const ValidationList = styled.ul`
  columns: 2;
  line-height: 1.4;
`;
